import React, { useState } from 'react';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { useParams } from 'react-router-dom';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteDkpLocationQuery, fetchDkpLocationsQuery } from 'app/edozvola/cases/case-location/service/case-location.queries';
import { DkpLocationView } from 'app/edozvola/cases/case-location/model/case-location.model';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

const CaseLocationDkpLocationTable = ({ setDkpLocationId, setReadOnly }) => {
  const { id } = useParams<{ id: string }>();
  const [idDkpLocationToDelete, setIdDkpLocationToDelete] = useState();
  const [deleteModalShown, setDeleteModalShown] = useState(false);
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.DKP_LOCATIONS_TABLE);

  const { mutate: deleteDkpLocationMutation, isPending: dkpLocationDeletionPending } = deleteDkpLocationQuery();

  const openDeleteDialog = idToDelete => {
    setIdDkpLocationToDelete(idToDelete);
    setDeleteModalShown(true);
  };

  const removeDkpLocation = () => {
    setDeleteModalShown(false);
    deleteDkpLocationMutation(idDkpLocationToDelete);
  };
  const openDkpLocationForm = (idDkpLocation: number, readOnly: boolean) => {
    setDkpLocationId(idDkpLocation);
    setReadOnly(readOnly);
  };

  const renderTableRow = (value: DkpLocationView, dkpLocationIndex: number, totalItems: number) => {
    return (
      <tr key={dkpLocationIndex} className={invalidRowIds.includes(value.idDkpLocation) ? 'invalid-table-row' : ''}>
        <td>{value.cadastralMunicipality}</td>
        <td>{value.cadastralParcel}</td>
        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canEdit && (
              <TooltipWrapper message={'Uredi'}>
                <FontAwesomeIcon
                  icon={'pen-to-square'}
                  className={'icon-table'}
                  onClick={() => openDkpLocationForm(value.idDkpLocation, false)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon icon={'trash-alt'} className={'icon-table'} onClick={() => openDeleteDialog(value.idDkpLocation)} />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        renderTableRow={renderTableRow}
        noDataMessage={'Nema dodanih katastarskih podataka'}
        initialPaginationColumn={'idDkpLocation'}
        fetchDataQuery={fetchDkpLocationsQuery}
        fetchDataProps={[id]}
      >
        <ViewTableHeaderColumn renderSort sortKey={'cadastralMunicipality'} columnLabels={['Katastarska općina']} width={'20%'} />
        <ViewTableHeaderColumn renderSort sortKey={'cadastralParcel'} columnLabels={['Katastarska čestica']} width={'20%'} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'3%'} />
      </ViewTable>
      <Modal scrollable isOpen={deleteModalShown} size={'lg'} toggle={() => setDeleteModalShown(false)} centered>
        <ModalHeader>
          <span>Brisanje općine</span>
        </ModalHeader>
        <ModalBody>
          <div>Jeste li sigurni da želite obrisati podatke?</div>
        </ModalBody>
        <ModalFooter>
          <Button size={'lg'} label="Odustani" outline onClick={() => setDeleteModalShown(false)} />
          <Button size={'lg'} label="Obriši" color={'danger'} onClick={removeDkpLocation} />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default CaseLocationDkpLocationTable;
